import { render, staticRenderFns } from "./BP_editor_check_list.vue?vue&type=template&id=0781914c"
import script from "./BP_editor_check_list.vue?vue&type=script&lang=js"
export * from "./BP_editor_check_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports